module.exports = __webpack_public_path__ + "img/framework.8668f629.png";